export enum AttachmentType {
	ACCESSIBILITY_ADVICE = 'ACCESSIBILITY_ADVICE',
	BANK_ACCOUNT_IDENTITY = 'BANK_ACCOUNT_IDENTITY',
	COFINANCIERS = 'COFINANCIERS',
	COST_ESTIMATE = 'COST_ESTIMATE',
	ENVIRONMENTAL_PERMIT = 'ENVIRONMENTAL_PERMIT',
	EXPLOTATION_DESCRIPTION = 'EXPLOTATION_DESCRIPTION',
	FIRE_DEPARTMENT_REPORT = 'FIRE_DEPARTMENT_REPORT',
	OWNER_AGREEMENT = 'OWNER_AGREEMENT',
	PICTURE_LOCATION = 'PICTURE_LOCATION',
	PROJECT_PLAN = 'PROJECT_PLAN',
	QUOTATION = 'QUOTATION',
	STATUTES_AND_BALANCE_SHEETS = 'STATUTES_AND_BALANCE_SHEETS',

	SELF_SCAN = 'SELF_SCAN',
	SUSTAINABILITY_PLAN = 'SUSTAINABILITY_PLAN',
	PROJECT_CLARIFICATION = 'PROJECT_CLARIFICATION',

	STO_REPORT = 'STO_REPORT',
	PICTURE_CURRENT_INSTALLATION = 'PICTURE_CURRENT_INSTALLATION',

	POLICY_PLAN = 'POLICY_PLAN',
	BUDGET = 'BUDGET',
}

export const TVA_ATTACHMENT_TYPES = [
	AttachmentType.ACCESSIBILITY_ADVICE,
	AttachmentType.COFINANCIERS,
	AttachmentType.COST_ESTIMATE,
	AttachmentType.ENVIRONMENTAL_PERMIT,
	AttachmentType.EXPLOTATION_DESCRIPTION,
	AttachmentType.FIRE_DEPARTMENT_REPORT,
	AttachmentType.PROJECT_PLAN,
	AttachmentType.QUOTATION,
	AttachmentType.STATUTES_AND_BALANCE_SHEETS,
];

export const LOGIES_ATTACHMENT_TYPES = [
	AttachmentType.OWNER_AGREEMENT,
	AttachmentType.PICTURE_LOCATION,
	AttachmentType.PROJECT_PLAN,
	AttachmentType.QUOTATION,
	AttachmentType.PICTURE_CURRENT_INSTALLATION
];
